import { useAuth } from 'src/contexts/AuthContext';

export const usePermission = () => {
  const { permissions, currentUser } = useAuth();
  const isSysAdmin = currentUser?.sysAdmin ?? false;

  const hasPermission = (...perms: string[]): boolean => isSysAdmin || perms.some((p) => permissions?.includes(p));

  return { hasPermission, isSysAdmin };
};
